module.exports = __webpack_public_path__ + "media/images/icons/icon-gradient-minus-c7d1a059a4588a01aa18756321204681.png";